var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41012 21L6.12012 17H2.12012L2.47012 15H6.47012L7.53012 9H3.53012L3.88012 7H7.88012L8.59012 3H10.5901L9.88012 7H15.8801L16.5901 3H18.5901L17.8801 7H21.8801L21.5301 9H17.5301L16.4701 15H20.4701L20.1201 17H16.1201L15.4101 21H13.4101L14.1201 17H8.12012L7.41012 21H5.41012ZM9.53012 9L8.47012 15H14.4701L15.5301 9H9.53012Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.75a04996f5f8a456c20285bfc9310bc2.svg";
export { ForwardRef as ReactComponent };